
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 0a8.255 8.255 0 00-8.255 8.256c0 3.476 4.798 11.486 7.078 15.096a1.394 1.394 0 002.354 0c2.28-3.611 7.079-11.62 7.079-15.096A8.256 8.256 0 0012 0zm0 13.297a4.67 4.67 0 110-9.339 4.67 4.67 0 010 9.339z","fill":"#838383"}})])
          )
        }
      }
    